// Phones and tablets get a smaller copy of the big pictures in public/images (made by scripts/make-responsive-images.js).
// Use:  <img {...responsiveImage('/images/matrimony-hero.png')} alt="..." />
// The browser picks the smallest file that is still sharp for the screen; the original is the fallback.
const FULL_WIDTH = {
    '/images/matrimony-hero.png': 1600,
    '/images/christian-hero.jpg': 1376,
    '/images/muslim-hero.jpg': 1376,
    '/images/horoscope-hero.jpg': 1376,
    '/images/horoscope-celebration.png': 1600,
    '/images/christian-horoscope.jpg': 1264,
    '/images/muslim-horoscope.jpg': 1264,
    '/images/success-hero.jpg': 1200,
};

export const responsiveImage = (src, sizes = '100vw') => {
    const full = FULL_WIDTH[src];
    if (!full) return { src };
    const base = src.replace(/\.\w+$/, '');
    return {
        src,
        srcSet: `${base}-640.webp 640w, ${base}-1024.webp 1024w, ${base}-full.webp ${full}w`,
        sizes,
    };
};
